import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "../../../programs.css";
import sampleImage from "../../../Image/faq.jpg";

const newsData = [
  {
    title: "What skills are important in the psychology field?",
    category: "Technology",
    description:
      "Important skills include empathy, communication, observation, critical thinking, emotional intelligence, research abilities, and ethical decision-making. These skills help professionals understand people effectively and support them through psychological challenges.",
  },
  {
    title: "What career roles are available in psychology?",
    category: "Trending",
    description:
      "Psychology offers roles like Clinical Psychologist, Counseling Psychologist, Organizational Psychologist, Child Psychologist, School Counselor, Forensic Psychologist, Research Analyst, Mental Health Worker, and Behavioral Therapist across hospitals, schools, and corporate settings.",
  },
  {
    title: "What industries hire psychology professionals?",
    category: "Design",
    description:
      "Industries such as healthcare, education, corporate HR, marketing, research, mental health services, social work, law enforcement, and rehabilitation centers actively hire psychology professionals for behavioral analysis and support services.",
  },
  {
    title: "What is counseling psychology?",
    category: "Design",
    description:
      "Counseling psychology helps individuals deal with personal challenges, stress, relationships, career concerns, and emotional issues through guidance, talk therapy, coping strategies, and supportive counseling sessions focused on well-being.",
  },
  {
    title: "Is psychology helpful in daily life?",
    category: "Design",
    description:
      "Yes. Psychology improves communication, decision-making, emotional control, stress management, relationship handling, and problem-solving. Daily situations become easier to manage with better understanding of thoughts and behaviors.",
  },
];

const FAQ = () => {
  const [expandedIndex, setExpandedIndex] = useState(null);

  const toggleDescription = (i) => {
    setExpandedIndex(expandedIndex === i ? null : i);
  };

  return (
    <div className="faq-wrapper">
      <motion.h2
        className="faq-heading"
        initial={{ opacity: 0, y: -20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        FAQ — Frequently Asked Questions
      </motion.h2>
      <div className="news-section-container">
        <motion.div
          className="news-left-image"
          initial={{ opacity: 0, rotateY: -90 }}
          whileInView={{ opacity: 1, rotateY: 0 }}
          transition={{
            duration: 0.9,
            ease: "easeOut",
            delay: 0.2,
          }}
          viewport={{ once: false, amount: 0.4 }}
        >
          <img src={sampleImage} alt="Main Preview" />
        </motion.div>

        <motion.div
          className="news-right-list"
          initial={{ opacity: 0, scale: 0.8, y: 40 }}
          whileInView={{ opacity: 1, scale: 1, y: 0 }}
          transition={{
            duration: 0.8,
            ease: "easeOut",
            delay: 0.3,
          }}
          viewport={{ once: false, amount: 0.3 }}
        >
          {newsData.map((item, index) => (
            <motion.div
              key={index}
              className="news-item"
              whileHover={{ x: 10, backgroundColor: "#eefef6" }}
              transition={{ duration: 0.3 }}
              onClick={() => toggleDescription(index)}
            >
              <div className="row">
                <div className="title">{item.title}</div>

                {/* <div className="category">{item.category}</div> */}

                <motion.div
                  animate={{ rotate: expandedIndex === index ? 90 : 0 }}
                  transition={{ duration: 0.3 }}
                  className="arrow"
                >
                  ➤
                </motion.div>
              </div>

              <AnimatePresence>
                {expandedIndex === index && (
                  <motion.div
                    className="card-description"
                    layout
                    initial={{ opacity: 0, maxHeight: 0 }}
                    animate={{ opacity: 1, maxHeight: 800 }}
                    exit={{ opacity: 0, maxHeight: 0 }}
                    transition={{
                      duration: 0.45,
                      ease: "easeInOut",
                    }}
                  >
                    {item.description}
                  </motion.div>
                )}
              </AnimatePresence>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </div>
  );
};

export default FAQ;
